/*
  OFFSET: keep the Klaviyo popup out of the cart's way. Xavier, 3 Oct 2026.

  Two problems, one file.

  1. Closing the popup closed the cart with it. The theme's dialog base class
     hides itself on ANY click that lands outside its own element, in
     _allowOutsideClickMouse in theme.js. Klaviyo appends its popup to <body>,
     so the popup's close button counts as "outside" the cart drawer and
     taking it shut the drawer too. Somebody with their thumb on Checkout lost
     the whole panel for tapping an X that had nothing to do with it.

  2. The popup showed over an open cart at all. A shopper reading their
     subtotal is the worst moment to ask for an email address, so while the
     drawer is open the popup waits. It comes back the moment the cart closes,
     so nothing is lost, it is only moved out of the buying decision.

  Nothing here touches Klaviyo's own script. The app injects that and we do not
  control it, so this only reacts to what it puts on the page.
*/
(function () {
  'use strict';

  var DRAWER_ID = 'cart-drawer';

  /* Klaviyo wraps a form in kl-private-reset-css-* around klaviyo-form-*.
     Matching on the name rather than one exact class means a Klaviyo markup
     change does not quietly bring the bug back. data-keep-cart-open is the
     escape hatch if another app ever lands in the same spot. */
  var KL = '[class*="klaviyo"],[id*="klaviyo"],[class*="kl-private"],[data-keep-cart-open]';

  function inKlaviyo(node) {
    return !!(node && node.closest && node.closest(KL));
  }

  /* ---------------------------------------------- 1. stop the double close -- */

  function patchDialog() {
    var Dialog = window.customElements.get('dialog-element');
    if (!Dialog || Dialog.prototype.__offsetKlaviyoPatched) return;
    var p = Dialog.prototype;
    p.__offsetKlaviyoPatched = true;

    var mouse = p._allowOutsideClickMouse;
    p._allowOutsideClickMouse = function (event) {
      /* Returning TRUE matters here. focus-trap calls preventDefault when this
         comes back false, which would stop the popup's own close button from
         working at all. We want the click to go through untouched, we just do
         not want the drawer to read it as "clicked away". */
      if (event && event.type === 'click' && inKlaviyo(event.target)) return true;
      return mouse.call(this, event);
    };

    var touch = p._allowOutsideClickTouch;
    p._allowOutsideClickTouch = function (event) {
      /* The original returns false on touch as well, so this keeps focus-trap
         behaving exactly as it did and only skips the hide it would otherwise
         schedule for touchend. */
      if (event && inKlaviyo(event.target)) return false;
      return touch.call(this, event);
    };
  }

  if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined('dialog-element').then(patchDialog);
  }
  patchDialog();

  /* ------------------------------------- 2. hold the popup while cart is open -- */

  var hidden = [];

  function roots() {
    var out = [];
    var nodes = document.querySelectorAll(KL);
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      // Only the outermost match, so we never fight a parent and child.
      if (n.parentElement && n.parentElement.closest && n.parentElement.closest(KL)) continue;
      out.push(n);
    }
    return out;
  }

  /* The footer signup is a Klaviyo embed that belongs in the page and must be
     left alone. Only the floating popup and its teaser sit on top of the cart,
     and those are the ones pinned with position:fixed. */
  function isOverlay(el) {
    try {
      if (getComputedStyle(el).position === 'fixed') return true;
      var kids = el.querySelectorAll('*');
      var cap = Math.min(kids.length, 40);
      for (var i = 0; i < cap; i++) {
        if (getComputedStyle(kids[i]).position === 'fixed') return true;
      }
    } catch (err) {}
    return false;
  }

  function hideAll() {
    roots().forEach(function (el) {
      if (el.__offsetHidden || !isOverlay(el)) return;
      el.__offsetHidden = true;
      el.__offsetVis = el.style.visibility;
      el.__offsetPtr = el.style.pointerEvents;
      /* visibility, not display. Klaviyo measures its own form as it opens and
         a display:none box measures zero, which is how popups come back the
         wrong size. This keeps the box and just takes it off screen. */
      el.style.visibility = 'hidden';
      el.style.pointerEvents = 'none';
      hidden.push(el);
    });
  }

  function showAll() {
    hidden.forEach(function (el) {
      el.style.visibility = el.__offsetVis || '';
      el.style.pointerEvents = el.__offsetPtr || '';
      el.__offsetHidden = false;
    });
    hidden = [];
  }

  function isOpen() {
    var d = document.getElementById(DRAWER_ID);
    return !!(d && d.hasAttribute('open'));
  }

  function sync() {
    if (isOpen()) hideAll();
    else showAll();
  }

  var timer = null;
  function syncSoon() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { timer = null; sync(); }, 50);
  }

  function watch() {
    var d = document.getElementById(DRAWER_ID);
    if (!d || d.__offsetKlWatched) return;
    d.__offsetKlWatched = true;
    new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['open'] });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }

  /* Klaviyo loads late and can open a form while the cart is already up, so a
     popup that arrives mid-session gets held back the same way. This also
     catches the drawer itself if it is rendered after this script runs. */
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      if (records[i].addedNodes && records[i].addedNodes.length) {
        watch();
        if (isOpen()) syncSoon();
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
